var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _path, _path2, _path3, _rect15, _rect16, _rect17, _rect18;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoAppFor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 112,
    viewBox: "0 0 112 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.30495,
    y: 4.30495,
    width: 102.883,
    height: 102.883,
    fill: "white",
    fillOpacity: 0.1,
    stroke: "white",
    strokeWidth: 1.00834
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 38.8924,
    y: 4.05055,
    width: 33.7086,
    height: 34.3421,
    stroke: "white",
    strokeOpacity: 0.6,
    strokeWidth: 0.499547
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 38.6426,
    y: 38.6426,
    width: 34.2081,
    height: 34.8416,
    fill: "white",
    fillOpacity: 0.02
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 38.8924,
    y: 38.8924,
    width: 33.7086,
    height: 34.3421,
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.499547
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 38.8924,
    y: 73.1013,
    width: 33.7086,
    height: 34.3421,
    stroke: "white",
    strokeOpacity: 0.4,
    strokeWidth: 0.499547
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 72.8516,
    y: 3.80078,
    width: 34.8416,
    height: 34.8416,
    fill: "white",
    fillOpacity: 0.02
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 73.1013,
    y: 4.05055,
    width: 34.3421,
    height: 34.3421,
    stroke: "white",
    strokeOpacity: 0.42,
    strokeWidth: 0.499547
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 72.3123,
    y: 37.9881,
    width: 34.8048,
    height: 34.8048,
    stroke: "white",
    strokeOpacity: 0.44,
    strokeWidth: 0.499547
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 72.8516,
    y: 72.8516,
    width: 34.8416,
    height: 34.8416,
    fill: "white",
    fillOpacity: 0.02
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 73.1013,
    y: 73.1013,
    width: 34.3421,
    height: 34.3421,
    stroke: "white",
    strokeOpacity: 0.42,
    strokeWidth: 0.499547
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 3.80078,
    y: 3.80078,
    width: 34.8416,
    height: 34.8416,
    fill: "white",
    fillOpacity: 0.02
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 4.05055,
    y: 4.05055,
    width: 34.3421,
    height: 34.3421,
    stroke: "white",
    strokeOpacity: 0.42,
    strokeWidth: 0.499547
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 4.05055,
    y: 38.8924,
    width: 34.3421,
    height: 34.3421,
    stroke: "white",
    strokeOpacity: 0.4,
    strokeWidth: 0.499547
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 4.05055,
    y: 73.1013,
    width: 34.3421,
    height: 34.3421,
    stroke: "white",
    strokeOpacity: 0.15,
    strokeWidth: 0.499547
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2383 72.2081H23.6998V58.3348H35.2926V51.8733H23.6998V44.4615H38.1433V38H17.2383V72.2081Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7795 73.0763C59.0244 73.0763 61.8186 72.3702 64.1621 70.9581C66.5206 69.546 68.3309 67.5705 69.5928 65.0317C70.8697 62.4929 71.5082 59.5409 71.5082 56.1758C71.5082 52.8108 70.8697 49.8588 69.5928 47.32C68.3309 44.7812 66.5206 42.8057 64.1621 41.3936C61.8186 39.9815 59.0244 39.2754 55.7795 39.2754C52.5346 39.2754 49.7329 39.9815 47.3743 41.3936C45.0308 42.8057 43.2206 44.7812 41.9436 47.32C40.6817 49.8588 40.0508 52.8108 40.0508 56.1758C40.0508 59.5409 40.6817 62.4929 41.9436 65.0317C43.2206 67.5705 45.0308 69.546 47.3743 70.9581C49.7329 72.3702 52.5346 73.0763 55.7795 73.0763ZM55.7795 67.3076C52.6998 67.2625 50.3863 66.241 48.839 64.243C47.3067 62.245 46.5406 59.5559 46.5406 56.1758C46.5406 52.7958 47.3067 50.0842 48.839 48.0411C50.3863 45.998 52.6998 44.999 55.7795 45.0441C58.8741 45.0891 61.1876 46.1107 62.7199 48.1087C64.2522 50.1067 65.0184 52.7958 65.0184 56.1758C65.0184 59.5559 64.2522 62.2675 62.7199 64.3106C61.1876 66.3537 58.8741 67.3527 55.7795 67.3076Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M72.2383 72.8501H78.546V61.472H85.5726L91.0686 72.8501H98.2111L92.1817 60.3994C94.0833 59.529 95.4824 58.2155 96.3791 56.4591C97.2913 54.6871 97.7473 52.6586 97.7473 50.3737C97.7473 47.5447 97.0594 45.1354 95.6834 43.1458C94.3075 41.1562 92.1199 39.9282 89.1206 39.4619C88.6878 39.3842 88.193 39.3376 87.6365 39.322C87.0954 39.2909 86.6625 39.2754 86.3378 39.2754H72.2383V72.8501ZM78.546 55.5498V45.1976H86.0595C86.3842 45.1976 86.7398 45.2131 87.1263 45.2442C87.5128 45.2753 87.8684 45.3375 88.193 45.4307C89.0433 45.6639 89.7004 46.0603 90.1642 46.6198C90.628 47.1639 90.9449 47.7779 91.115 48.4618C91.3005 49.1302 91.3933 49.7675 91.3933 50.3737C91.3933 50.9799 91.3005 51.625 91.115 52.3089C90.9449 52.9773 90.628 53.5913 90.1642 54.1508C89.7004 54.6949 89.0433 55.0835 88.193 55.3166C87.8684 55.4099 87.5128 55.4721 87.1263 55.5031C86.7398 55.5342 86.3842 55.5498 86.0595 55.5498H78.546Z",
    fill: "white"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    width: 7.60181,
    height: 7.60181,
    fill: "white"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 103.891,
    y: 103.891,
    width: 7.60181,
    height: 7.60181,
    fill: "white"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    y: 103.891,
    width: 7.60181,
    height: 7.60181,
    fill: "white"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 103.891,
    y: 0.632812,
    width: 7.60181,
    height: 7.60181,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoAppFor);
export default __webpack_public_path__ + "static/media/LogoApp_FOR.f383b2b49fa7312e7474c584535ae1c5.svg";
export { ForwardRef as ReactComponent };